import React, { Component } from 'react';
import Video from '../Video';

class HowItWorksVideo extends Component {
  render () {
    return (
      <section className='how-it-works'>
        <h2 className='alpha'>How it works, in 90 seconds</h2>
        <div className='video-container' style={{height: 432}}>
          <div className='video-container__inner'>
            <Video
              src='https://player.vimeo.com/video/313205177'
              width={768}
              height={432}
              />
          </div>
        </div>
      </section>
    );
  }
}

export default HowItWorksVideo;



// WEBPACK FOOTER //
// ./src/components/HowItWorksVideo/index.js